import React from "react";
import styles from './selectedcom.module.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

export function SelectedInput({ placeholder, type, value, onChange, name, classname, lab }) {
    return (
        <div className={styles.inputcontainer}>
            {classname === 'driverSearch' ?
                <div className={styles.searchcontainer}>
                    <FontAwesomeIcon icon={faSearch} />
                    <input
                        id={name}
                        type={type}
                        {...(value !== undefined && value !== null ? { value } : {})}
                        onChange={onChange} // Always use onChange
                        name={name}
                        className={classname ? styles[classname] : styles.input}
                        placeholder={lab ? '' : placeholder}
                        autoComplete="off"
                    />
                </div>
                :

                <input
                    id={name}
                    type={type}
                    {...(value !== undefined && value !== null ? { value } : {})}
                    onChange={onChange} // Always use onChange
                    name={name}
                    className={classname ? styles[classname] : styles.input}
                    placeholder={lab ? '' : placeholder}
                    autoComplete="off"
                />}
            {lab && <label className={styles.label} htmlFor={name}>
                {placeholder}
            </label>}
        </div>
    );
}

export function SelectedOption({ name, options, onChange, defaultValue }) {
    return (
        <div className={styles.inputcontainer}>
            <select
                name={name}
                className={styles.select}
                onChange={onChange}
                defaultValue="">
                <option value="" disabled>{defaultValue}</option>
                {options.map((option) => (
                    <option key={option} value={option}>{option}</option>
                ))}
            </select>
        </div>
    )

}
